import { render } from "./ExamOthersTab.vue?vue&type=template&id=f891ba3e&scoped=true"
import script from "./ExamOthersTab.vue?vue&type=script&lang=js"
export * from "./ExamOthersTab.vue?vue&type=script&lang=js"

import "./ExamOthersTab.vue?vue&type=style&index=0&id=f891ba3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f891ba3e"]])

export default __exports__